import { useShallow } from 'zustand/react/shallow';

import {
  selectIsMigrationCompleted,
  selectIsMigrationTradingBlocked,
  useMigrationStore,
} from '@/store/use-migration-store';

export type MigrationBlockReason = 'none' | 'moving' | 'moved' | 'empty';

export type MigrationTradingBlock = {
  isBlocked: boolean;
  reason: MigrationBlockReason;
};

export const getMigrationBlockButtonKey = (reason: MigrationBlockReason) => {
  switch (reason) {
    case 'empty':
      return 'migration.block.emptyButton';
    case 'moved':
      return 'migration.block.movedButton';
    default:
      return 'migration.block.movingButton';
  }
};

export const getMigrationBlockTooltipKey = (reason: MigrationBlockReason) => {
  switch (reason) {
    case 'empty':
      return 'migration.block.emptyTooltip';
    case 'moved':
      return 'migration.block.movedTooltip';
    default:
      return 'migration.block.movingTooltip';
  }
};

const getBlock = (
  state: Parameters<typeof selectIsMigrationTradingBlocked>[0],
): MigrationTradingBlock => {
  const isBlocked = selectIsMigrationTradingBlocked(state);
  if (!isBlocked) return { isBlocked, reason: 'none' };
  const { status } = state;
  if (status?.started) {
    return {
      isBlocked,
      reason: status.state === 'completed' ? 'moved' : 'moving',
    };
  }
  const isEmptyBlock = state.orderGateLockedAt === null && state.isAccountEmpty;
  return { isBlocked, reason: isEmptyBlock ? 'empty' : 'moving' };
};

export function useMigrationTradingBlock(): MigrationTradingBlock {
  return useMigrationStore(useShallow(getBlock));
}

export function useIsMigrated(): boolean {
  return useMigrationStore(selectIsMigrationCompleted);
}

export function getIsMigrationTradingBlocked(): boolean {
  return selectIsMigrationTradingBlocked(useMigrationStore.getState());
}
